import { useState } from "react";
import "./Dashboard.css";
import Live from "./live/Live";
import WorkTimeAccount from "./workTimeAccount/WorkTimeAccount";
import Absences from "./absences/Absences";
import WorkTime from "./workTime/WorkTime";

function Dashboard() {

    const [workTimeAccountIsActive, setWorkTimeAccountIsAktive] = useState(true);

    function generateDashboard() {
        return workTimeAccountIsActive ?
            <>
                <div className="half-width-content-container">
                    <WorkTime />
                </div>
                <div className="half-width-content-container">
                    <Live />
                </div>
                <div className="half-width-content-container">
                    <WorkTimeAccount onAccountsExist={setWorkTimeAccountIsAktive} />
                </div>
                <div className="half-width-content-container">
                    <Absences />
                </div>
            </> 
            :
            <>
                <div className="half-width-content-container">
                    <WorkTime />
                </div>
                <div className="half-width-content-container">
                    <Live />
                </div>
                <div className="full-width-content-container">
                    <Absences />
                </div>
            </>
    }

    return <div className="dashboard-container">
        {generateDashboard()}
    </div>
}

export default Dashboard;
